export const copyToClipboard = textToCopy => {
    navigator.clipboard.writeText(textToCopy);
};
